module.exports = __webpack_public_path__ + "img/listview-deletejob.0e19c56f.svg";